import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type RememberMeState = {
    rememberMe: {
        email: string
    } | null
    setEmail: (value: string) => void
    forgetMe: () => void
    openAvaliacao: boolean | null
    emailAvaliacao: string | null
}

export const rememberMeStore = create(
    persist<RememberMeState>(
        set => ({
            emailAvaliacao: null,
            openAvaliacao: null,
            rememberMe: null,
            setEmail: (value: string) => {
                set({ rememberMe: { email: value } })
            },
            forgetMe: () => {
                set({ rememberMe: null })
            },
        }),
        {
            name: 'remember-me',
        },
    ),
)
